import { render } from "./UsTaxCodes.vue?vue&type=template&id=d5eb1a7c"
import script from "./UsTaxCodes.vue?vue&type=script&lang=js"
export * from "./UsTaxCodes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__